import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/metaverse-new/meta_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Top Metaverse Development Company in USA
              </h1>
              <span>Develop Virtual Environments for Immersive Engagement</span>
              <p style={{ marginTop: "10px" }}>
                From creating digital twins powered by extended reality to
                launching NFT marketplaces to boost virtual economies,
                TekRevol’s extensive metaverse development services realize your
                imaginary world for top performance and immersive experiences.
                With high-end cross-platform development and edge computing we
                build personalized digital spaces that are secure and
                high-performing.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Metaverse Idea
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
